import { useNavigate } from "react-router-dom";

export default function Header() {
    const navigate = useNavigate();

    return (
    <header className="fixed top-0 left-0 w-full bg-[#161B22]/80 backdrop-blur-md border-b border-[#21262D] z-50">
        <div className="max-w-6xl mx-auto flex items-center justify-between py-4 px-6">
        {/* Logo */}
        <h1
            className="text-2xl font-bold text-[#3B82F6] cursor-pointer"
            onClick={() => navigate("/")}
        >
            BoostMyHook
        </h1>

        {/* Boutons */}
        <div className="flex items-center gap-3">
            <button
            onClick={() => navigate("/login")}
            className="text-[#E6EDF3] hover:text-[#3B82F6] font-medium transition"
            >
            Login
            </button>
            <button
            onClick={() => navigate("/register")}
            className="bg-[#3B82F6] hover:bg-[#2563EB] text-white px-4 py-2 rounded-full font-medium transition"
            >
            Try Now
            </button>
        </div>
        </div>
    </header>
    );
}
